import React from 'react';

export interface StatCardProps {
    icon: React.ReactNode;
    title: string;
    value: string;
    subtitle: string;
    subtitleColor?: 'green' | 'gold' | 'default';
    onClick?: () => void;
    clickable?: boolean;
}

export const StatCard: React.FC<StatCardProps> = ({
    icon,
    title,
    value,
    subtitle,
    subtitleColor = 'default',
    onClick,
    clickable = false,
}) => {
    const subtitleColorClass =
        subtitleColor === 'green'
            ? 'home-subtitle-green'
            : subtitleColor === 'gold'
            ? 'home-subtitle-gold'
            : 'home-subtitle-default';

    return (
        <div
            className={`home-stat-card ${clickable ? 'home-stat-card-clickable' : ''}`}
            onClick={clickable ? onClick : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={clickable ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick?.();
                }
            } : undefined}
        >
            <div className="home-stat-card-inner">
                <div className="home-stat-icon-wrap">{icon}</div>
                <div className="home-stat-content">
                    <div className="home-stat-card-header">{title}</div>
                    <div className="home-stat-card-value">{value}</div>
                    <div className={`home-stat-card-subtitle ${subtitleColorClass}`}>{subtitle}</div>
                </div>
            </div>
        </div>
    );
};

export default StatCard;
